/**
 * Is used to identify vehicle fields within the components to set their visibilities.
 */
export enum VehicleField {
  VIN_SEARCH = 'VIN_SEARCH',
  LICENSE_SEARCH = 'LICENSE_SEARCH',
}
